export enum ReportTypes {
  depositInvoice = 'DI',
  despatchNote = 'DS',
  invoice = 'IV',
  purchaseOrderPrint = 'PO',
  pickingList = 'PK',
  proforma = 'PF',
  quotation = 'QT',
  salesOrderConfirmation = 'SO',
  salesOrderBalances = 'SB',
  salesOrderBackOrder = 'BK',
  supplierPickingList = 'SP',
}
